module.exports = __webpack_public_path__ + "static/img/05.87f0506.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/05.jpg
// module id = 7voV
// module chunks = 0